import { render, staticRenderFns } from "./PaymentAditional.vue?vue&type=template&id=06319068"
import script from "./PaymentAditional.vue?vue&type=script&lang=js"
export * from "./PaymentAditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports